import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors } from '../reducer'
import { selectors as globalSelectors } from 'global-reducer'
import { PageHeader } from 'components'
import {
  Memberships,
  MembershipNotificationCenter,
  SidePanel,
} from '../components'
import { SavingsClubDirectory } from 'savings-club/components'
import { AccountType, AllMembershipsType, ContactType } from 'types'
import { displayNameForAccount } from 'utils'

const propTypes = {
  account: AccountType.isRequired,
  allMemberships: AllMembershipsType,
  primaryContact: ContactType,
}

function Dashboard({ account, allMemberships, primaryContact }) {
  const { memberships } = allMemberships
  const welcomeName = displayNameForAccount(account, primaryContact)

  return (
    <>
      <PageHeader headerText={`Welcome back, ${welcomeName}`} />
      <div className="dashboard-block-container">
        <MembershipNotificationCenter memberships={memberships} />
        <div className="content-with-aside-wrapper">
          <div className="content-with-aside">
            <Memberships />
            <SavingsClubDirectory memberships={memberships} />
          </div>
          <SidePanel account={account} />
        </div>
      </div>
    </>
  )
}

Dashboard.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: selectors.account(state),
    allMemberships: selectors.allMemberships(state),
    // Same primary as the nav. applicationPrefillContact reads the /dashboard
    // contacts snapshot, which does not update after Account contact edits.
    primaryContact: globalSelectors.primaryContact(state),
  }
}

export default compose(connect(mapStateToProps))(Dashboard)
